import React from 'react';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';

import PromoCodeActivateForm from './PromoCodeActivateForm';

interface IPromoCodeActivateModalProps {
    open: boolean;
    handleClose: () => void;
}

const PromoCodeActivateModal: React.FC<IPromoCodeActivateModalProps> = ({open, handleClose}) => {
    return (
        <MainModal
            header={t`Активация промокода`}
            open={open}
            handleClose={handleClose}
            size="sm"
        >
            <PromoCodeActivateForm
                onSuccess={handleClose}
                onClose={handleClose}
            />
        </MainModal>
    );
};

export default PromoCodeActivateModal;
